import { render } from "./Gyms.vue?vue&type=template&id=4de52110&scoped=true"
import script from "./Gyms.vue?vue&type=script&lang=js"
export * from "./Gyms.vue?vue&type=script&lang=js"

import "./Gyms.vue?vue&type=style&index=0&id=4de52110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de52110"]])

export default __exports__